import { USER_AUTH_STATUS } from "./actionTypes";

export const ChangeUserAuthStatusAction =(dispatch)=>{
    dispatch({type:USER_AUTH_STATUS})
}